'use client'

import Customers from '@/components/Customers'
import NoSSR from '@/components/NoSSR'

export default function Home() {
  return (
    <NoSSR>
      <div className="max-w-4xl mx-auto">
        <Customers />
      </div>
    </NoSSR>
  )
}
